import { useQuery } from "@tanstack/react-query"

import { FUEL_TYPE_QUERY_KEY, FUEL_TYPE_LIST_QUERY_KEY } from "@/constants/query"
import { getFuelType, getFuelTypeById, getFuelTypesSelectList } from "@/http/fuelType"

import { IRequestParams } from "@/types/api"

export const useFuelTypeQuery = (params?: IRequestParams, enable: boolean = true) => {
    return useQuery({
        queryFn: () => getFuelType(params || {}),
        queryKey: [FUEL_TYPE_QUERY_KEY, params],
        retry: false,
        enabled: enable
      })
}

export const useFuelTypeByIdQuery = (id: number) => {
    return useQuery({
        queryFn: () => getFuelTypeById(id),
        queryKey: [FUEL_TYPE_QUERY_KEY, id],
        enabled: id !== 0
      })
}

export const useFuelTypeSelectListQuery = () => {
    return useQuery({
        queryFn: () => getFuelTypesSelectList(),
        queryKey: [FUEL_TYPE_LIST_QUERY_KEY],
        retry: false
    })
}
